import employeesActions from '../actionTypes/employeesActions';

const initialState = {
  isLoading: true,
  openModal: false,
  isSubmitting: false,
  activeModalId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case employeesActions.toggleEmployeeForm:
      return {
        ...state,
        activeModalId: action.payload,
        openModal: !state.openModal,
      };
    case employeesActions.addNewEmployee:
    case employeesActions.updateEmployeeDetails:
      return { ...state, isSubmitting: true };
    case employeesActions.addNewEmployeeSuccess:
    case employeesActions.updateEmployeeDetailsSuccess:
      return {
        ...state,
        ...action.payload,
        isSubmitting: false,
        errors: null,
        openModal: false,
      };
    case employeesActions.addNewEmployeeFailed:
    case employeesActions.updateEmployeeDetailsFailed:
      return { ...state, ...action.payload, isSubmitting: false };
    case employeesActions.employeeProfileUpdate:
    case employeesActions.employeeProfileUpdateFailed:
      return {
        ...state,
        ...action.payload,
        isSubmitting: false,
        isLoading: false,
      };
    case employeesActions.employeeProfileUpdateSuccess:
      return {
        ...state,
        isSubmitting: false,
        errors: null,
      };
    case employeesActions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};
